import { render, staticRenderFns } from "./Diagnosis.vue?vue&type=template&id=37788c50&scoped=true&"
import script from "./Diagnosis.vue?vue&type=script&lang=js&"
export * from "./Diagnosis.vue?vue&type=script&lang=js&"
import style0 from "./Diagnosis.vue?vue&type=style&index=0&id=37788c50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37788c50",
  null
  
)

export default component.exports